import { Grid, MantineTheme } from "@mantine/core";
import RightSide, { ICheckInManyQuery } from "./RightSide";
import LeftSide from "./LeftSide";
import { useAppContext } from "src/api/AppContext";
import { PaymentStatus, SignedAgreementStatus } from "src/generated/graphql";

export const enum CheckInQueueStatus {
  Active = "Active",
  NotPaid = "Not Paid",
  ExpireInMonth = "Expire in Month",
  Denied = "Denied",
}

export function isWithinOneMonth(dateString: string): boolean {
  const currentDate = new Date();
  const expiryDate = new Date(dateString);
  const timeDifference = expiryDate.getTime() - currentDate.getTime();
  // Convert milliseconds to days
  const daysDifference = timeDifference / (1000 * 60 * 60 * 24);
  // Check if the difference is less than or equal to 30 days
  return daysDifference <= 30;
}

export const enum CheckInColors {
  Active = "#5CE3B1",
  Info = "#FFE8C5",
  Denied = "#FFE5E5",
}

export const enum CheckInColors_Dark {
  Active = "#5CE3B1",
  Info = "#b87e14",
  Denied = "#a23b3b",
}

const getColor = (type: string, theme: MantineTheme) => {
  switch (type) {
    case "Info":
      return theme.colorScheme == "light"
        ? CheckInColors.Info
        : CheckInColors_Dark.Info;
    case "Denied":
      return theme.colorScheme == "light"
        ? CheckInColors.Denied
        : CheckInColors_Dark.Denied;
    default:
      return theme.colors.secondary[4];
  }
};

export const getStatusObj = (
  memberships: ICheckInManyQuery[0]["client"]["memberships"],
  currentLocationId: string | undefined,
  theme: MantineTheme,
  isAccepted?: boolean
) => {
  // Filter out memberships based on currentLocationId
  if (currentLocationId) {
    memberships = memberships.filter(
      (m) => m.location.id === currentLocationId
    );
  }
  let checkForActive = memberships
    ?.filter((e) => e.status === SignedAgreementStatus.Active)
    .sort(
      (a, b) =>
        new Date(b.termStart).valueOf() - new Date(a.termStart).valueOf()
    );
  // Client has active membership status
  if (checkForActive.length > 0) {
    // check for payment status paid
    const paymentPaid = checkForActive.filter(
      (a) => a.subscription.paymentStatus === PaymentStatus.Paid
    );
    if (!paymentPaid.length)
      return {
        CheckInQueueStatus: CheckInQueueStatus.NotPaid,
        color: getColor("Info", theme), //CheckInColors.Info,
        memberId: checkForActive[0].id,
      };

    // Find membership whose expiry is greater than one month from now
    const filteredObj = paymentPaid.find(
      (item) => !isWithinOneMonth(item.termEnd)
    );
    return {
      CheckInQueueStatus: filteredObj
        ? CheckInQueueStatus.Active
        : CheckInQueueStatus.ExpireInMonth,
      color: filteredObj ? getColor("Active", theme) : getColor("Info", theme), //CheckInColors.Active : CheckInColors.Info,
      memberId: filteredObj ? filteredObj.id : paymentPaid[0].id,
    };
  } else {
    // isAccepted case show Active status and change color to green else denied status
    return {
      CheckInQueueStatus: isAccepted
        ? CheckInQueueStatus.Active
        : CheckInQueueStatus.Denied,
      color: isAccepted ? getColor("Active", theme) : getColor("Denied", theme), //CheckInColors.Active : CheckInColors.Denied,
      memberId: memberships?.[0]?.id || null,
    };
  }
};

function CheckInQueue() {
  const { selectedCheckInId } = useAppContext();
  return (
    <Grid m={0} sx={{ height: "92vh" }}>
      <Grid.Col sm={9} md={9.6} p={"md"}>
        {selectedCheckInId ? <LeftSide /> : <></>}
      </Grid.Col>
      <RightSide />
    </Grid>
  );
}

export default CheckInQueue;
